import { LessonsContainer } from '../../components';

const AllLessons = () => {
  return (
    <>
      <LessonsContainer />
    </>
  );
};

export default AllLessons;
